<template>
  <div class="note-with-vendor-code">
    <p
      class="note"
      v-if="jewel.note"
    >
      {{ jewel.note }}
    </p>
    <p
      class="vendor-code"
      v-if="jewel.vendor_code"
    >
      Артикул: <span itemprop="sku">{{ jewel.vendor_code }}</span>
    </p>
  </div>
</template>

<script>
export default {
  name: 'CatalogJewelArticleDescriptionNoteWithVendorCode',
  props: ['jewel'],
  data: function () {
    return {}
  }
}
</script>

<style scoped lang="scss">
  .note-with-vendor-code {
    margin-bottom: 2em;
    & > p {
      line-height: normal;
    }
    & > .note {
      font-family: "Baskerville Italic", $font-stack;
      margin-bottom: 0.25em;
      .wf-baskervilleitalic-n4-active & { font-size: 1.33em; }
    }
    & > .vendor-code {
      color: $default-heading-color;
      font-weight: bold;
    }
    & > *:last-child {
      margin-bottom: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/the-content/catalog-jewel-article/catalog-jewel-article-description/CatalogJewelArticleDescriptionNoteWithVendorCode.vue